import ToastService from '@/modules/toasts/services/ToastService';
import WCSimpleToast from '@/modules/toasts/components/WCSimpleToast/WCSimpleToast.vue';
import ItemModifierAddToCartMixin from '@/modules/itemModifiers/mixins/ItemModifierAddToCartMixin';
import CartControlsMixin from '@/modules/cart/mixins/CartControls/CartControls';

export default {
  mixins: [CartControlsMixin, ItemModifierAddToCartMixin],
  data() {
    return {
      outOfStockItems: [],
      inStoreOnlyItems: [],
      notAvailableItems: [],
      customizeItems: [],
    };
  },
  methods: {
    /**
     * Method to add all selected items to cart
     * @param {Array} checkedItems
     */
    addSelectedToCart(checkedItems) {
      this.outOfStockItems = [];
      this.inStoreOnlyItems = [];
      this.notAvailableItems = [];
      this.customizeItems = [];

      checkedItems.forEach(listItem => {
        if (!listItem.item.hasModifiers) this.addToCart(listItem.item, listItem.variation, false);
        else if (
          listItem.item.hasModifiers &&
          this.quantity(listItem.item, listItem.variation && listItem.variation.id).isZero()
        ) {
          this.addToCart(listItem.item, listItem.variation, true);
        }
      });
      /**
       * Display collective toasts for out of stock, instore only and not available items
       */
      if (this.outOfStockItems.length > 0) {
        ToastService.open(WCSimpleToast, {
          props: {
            variant: 'danger',
            title: this.$t('cannotAddItemToCart'),
            message: this.$t('outOfStockAlert', { name: this.outOfStockItems.join(', ') }),
          },
          timeout: 5000,
        });
      }
      if (this.inStoreOnlyItems.length > 0) {
        ToastService.open(WCSimpleToast, {
          props: {
            variant: 'danger',
            title: this.$t('cannotAddItemToCart'),
            message: this.$t('inStoreOnlyAlert', { name: this.inStoreOnlyItems.join(', ') }),
          },
          timeout: 5000,
        });
      }
      if (this.notAvailableItems.length > 0) {
        ToastService.open(WCSimpleToast, {
          props: {
            variant: 'danger',
            title: this.$t('cannotAddItemToCart'),
            message: this.$t('itemUnavailableAlert', { name: this.notAvailableItems.join(', ') }),
          },
          timeout: 5000,
        });
      }
      if (this.customizeItems.length > 0) {
        ToastService.open(WCSimpleToast, {
          props: {
            variant: 'danger',
            title: this.$t('cannotAddItemToCart'),
            message: this.$t('customizeListItemToAddToCartAlert', {
              itemName: this.customizeItems.join(', '),
            }),
          },
          timeout: 5000,
        });
      }
    },

    /**
     * Method to add individual item to cart based on instock and instore options
     * @param {Object} item
     * @param {Object} variation
     */
    async addToCart(item, variation, hasModifiers) {
      try {
        /** Check if there is any gift card items in cart, if not add the item to cart */
        if (!this.isGiftCard) {
          if (
            this.isInStock(item) &&
            this.quantity(item, variation && variation.id).isZero() &&
            !this.isInStoreOnly(item) &&
            !this.getMinimumQuantity(item).comparedTo(0) <= 0
          ) {
            if (!hasModifiers)
              await this.setQuantity(this.getMinimumQuantity(item), item, variation);
            else if (variation && variation.id) this.addItemModifierToCart(item, null, variation);
            else {
              this.customizeItems.push(item.name);
            }
          }
        }
        /** Else if there is gift card, show error toast */
        if (this.isGiftCard) {
          ToastService.open(WCSimpleToast, {
            props: {
              variant: 'danger',
              title: this.$t('cannotAddItemToCart'),
              message: this.$t('giftCardCartAlert'),
            },
            timeout: 5000,
          });
        }
        /** Check if item is inStock, then add, else show error toast */
        if (!this.isInStock(item)) {
          this.outOfStockItems.push(item.name);
        }
        /** Check if item is inStock, then add, else show error toast */
        if (this.isInStoreOnly(item)) {
          this.inStoreOnlyItems.push(item.name);
        }
        /** Check if item is available, then add, else show error toast */
        if (this.getMinimumQuantity(item).comparedTo(0) <= 0) {
          this.notAvailableItems.push(item.name);
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
